export default __webpack_public_path__ + "media/images/indent-right-white-30469362b9d80f6d3feef4ec4ac3a208.png";